import React, { useState } from "react";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import { IconDental, IconEye, IconEyeOff } from "@tabler/icons-react";
import "./login.scss";
import { useClinicData } from "../../context/ClinicDataContext";
import { isAuthenticated } from "../../components/ProtectedRoute";
import { BASE_PATH } from "../../components/AppLayout/AppLayout";

const LoginPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { clinic } = useClinicData();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  if (isAuthenticated()) return <Navigate to={BASE_PATH} replace />;

  const handleLogin = (e) => {
    e.preventDefault();
    if (!username || !password) {
      setErrorMessage("Enter your username and password.");
      return;
    }
    // Demo only: replace with a real call (see src/api/clinicApi.js).
    localStorage.setItem("token", "demo-token");
    navigate(location.state?.from || BASE_PATH, { replace: true });
  };

  return (
    <div className="login-page">
      <div className="login-page__card">
        <div className="login-page__brand">
          <span className={`login-page__mark ${clinic.logoUrl ? "login-page__mark--logo" : ""}`}>
            {clinic.logoUrl ? <img src={clinic.logoUrl} alt="" /> : <IconDental size={28} stroke={1.75} />}
          </span>
          <span>
            <strong>{clinic.name}</strong>
            <span>Dental admin</span>
          </span>
        </div>

        <h1 className="login-page__title">Log in</h1>
        <p className="login-page__subtitle">For clinic staff only.</p>

        <form className="login-page__form" onSubmit={handleLogin} noValidate>
          <label className="form-field">
            <span className="form-field__label">Username</span>
            <input
              className="form-field__control"
              type="text"
              value={username}
              autoComplete="username"
              onChange={(e) => {
                setUsername(e.target.value);
                setErrorMessage("");
              }}
            />
          </label>

          <label className="form-field">
            <span className="form-field__label">Password</span>
            <span className="login-page__password">
              <input
                className="form-field__control"
                type={showPassword ? "text" : "password"}
                value={password}
                autoComplete="current-password"
                onChange={(e) => {
                  setPassword(e.target.value);
                  setErrorMessage("");
                }}
              />
              <button
                type="button"
                className="login-page__reveal"
                aria-label={showPassword ? "Hide password" : "Show password"}
                onClick={() => setShowPassword((v) => !v)}
              >
                {showPassword ? <IconEyeOff size={20} stroke={1.75} /> : <IconEye size={20} stroke={1.75} />}
              </button>
            </span>
          </label>

          {errorMessage && (
            <p className="form-error" role="alert">
              {errorMessage}
            </p>
          )}

          <button type="submit" className="btn btn--primary login-page__submit">
            Log in
          </button>
        </form>
      </div>
    </div>
  );
};

export default LoginPage;
